import { render, staticRenderFns } from "./shopInventoryGrid.vue?vue&type=template&id=b518ea34&scoped=true"
import script from "./shopInventoryGrid.vue?vue&type=script&lang=js"
export * from "./shopInventoryGrid.vue?vue&type=script&lang=js"
import style0 from "./shopInventoryGrid.vue?vue&type=style&index=0&id=b518ea34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b518ea34",
  null
  
)

export default component.exports